<template>
	<section class="empiricus-pass">
    <div class="empiricus-pass-container">
      <p class="empiricus-pass--text">
        Seus colaboradores recebendo todo apoio e suporte para desenvolverem ainda mais sua saúde financeira.
      </p>

      <div class="empiricus-pass--points">

        <div class="empiricus-pass-point">
          <SVGLoader
            class="point-image"
            src="/static/svg/plantoes.svg"
          />
          <p>Plantões de dúvidas</p>
          <span>Tire as suas pricipais dúvidas financeiras</span>
        </div>

        <div class="empiricus-pass-point">
          <SVGLoader
            class="point-image"
            src="/static/svg/telegram.svg"
          />
          <p>Grupo VIP no Telegram</p>
          <span>Canal exclusivo para todos os assinantes.</span>
        </div>

        <div class="empiricus-pass-point-highlight">
          <div class="point-highlight-block">
            <SVGLoader
              class="point-image"
              src="/static/svg/analistas.svg"
            />
            <p>+ de 30 analistas</p>
            <span>focados em buscar oportunidades de investimento de alta rentabilidade.</span>
          </div>
        </div>

        <div class="empiricus-pass-point">
            <SVGLoader
              class="point-image"
              src="/static/svg/series.svg"
            />
          <p>Séries para todos os níveis</p>
          <span>8 assinaturas essencias, do básico ao avançado</span>
        </div>

      </div>
    </div>
  </section>
</template>
<script>
import SVGLoader from '@/components/SvgLoader'

export default {
  components: {
    SVGLoader
  },
}
</script>

<style lang="scss">
.empiricus-pass {
  background-color: var(--default-black);
  display: flex;
  justify-content: center;
  position: relative;

  &-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 40px 16px 40px 16px;
    max-width: 1256px;
    width: 100%;

    @media only screen and (min-width: 600px) {
      padding: 80px 32px;
    }

    @media only screen and (min-width: 1440px) {
      padding: 100px 16px;
    }
  }

}

.empiricus-pass--text {
  color: var(--white);
  font-size: 1.4375rem;
  font-weight: 700;
  line-height: 26px;
  margin-bottom: 20px !important;
  max-width: 1224px;
  text-align: left;
  width: 100%;

  @media only screen and (min-width: 600px) {
    font-size: 1.6875rem;
    line-height: 31px;
    margin-bottom: 46px !important;
    text-align: center;
  }

  @media only screen and (min-width: 1024px) {
    font-size: 1.9375rem;
    line-height: 35px;
    margin-bottom: 60px !important;
  }

  @media only screen and (min-width: 1440px) {
    font-size: 2.8125rem;
    line-height: 50px;
    margin-bottom: 94px !important;
  }
}

.empiricus-pass--points {
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1224px;
  row-gap: 16px;
  width: 100%;

  @media only screen and (min-width: 600px) {
    flex-wrap: nowrap;
    justify-content: center;
    row-gap: 0;
  }
}

.empiricus-pass-point,
.empiricus-pass-point-highlight,
.point-highlight-block {
  align-items: center;
  background-color: var(--black-090);
  display: flex;
  flex-direction: column;
  height: 196px;
  max-width: 100%;
  padding: 46px 12px;
  width: 100%;

  @media only screen and (min-width: 600px) {
    height: 230px;
    max-width: 176px;
    padding: 40px 0;
  }

  @media only screen and (min-width: 1024px) {
    height: 236px;
    max-width: 240px;
    padding: 46px 0;
  }

  @media only screen and (min-width: 1440px) {
    height: 318px;
    max-width: 306px;
    padding: 62px 0;
  }

  .point-image {
    background-color: var(--black-070);
    border-radius: 50%;
    color: var(--white) !important;
    display: flex;
    height: 40px;
    justify-content: center;
    margin-bottom: 8px;
    width: 40px;

    @media only screen and (min-width: 600px) {
      height: 42px;
      margin-bottom: 10px;
      width: 42px;
    }

    @media only screen and (min-width: 1024px) {
      height: 56px;
      width: 56px;
    }

    @media only screen and (min-width: 1440px) {
      height: 72px;
      margin-bottom: 20px;
      width: 72px;
    }

    svg {
      height: auto;
      width: 16px;

      @media only screen and (min-width: 600px) {
        width: 18px;
      }

      @media only screen and (min-width: 1024px) {
        width: 24px;
        height: 56px;
      }

      @media only screen and (min-width: 1440px) {
        width: 32px;
        height: 72px;
      }
    }
  }

  p {
    color: var(--grey-day-030);
    font-family: var(--dm-sans-bold);
    font-size: .75rem;
    margin-bottom: 8px;
    line-height: 16px;
    text-align: center;

    @media only screen and (min-width: 600px) {
      font-size: .875rem;
      line-height: 19px;
      margin-bottom: 10px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1rem;
      line-height: 21px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 1.25rem;
      line-height: 27px;
      margin-bottom: 20px;
    }
  }

  span {
    color: var(--light-grey);
    font-family: var(--dm-sans-regular);
    font-size: .75rem;
    line-height: 16px;
    max-width: 132px;
    text-align: center;

    @media only screen and (min-width: 600px) {
      font-size: .875rem;
      line-height: 19px;
      margin-bottom: 10px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1rem;
      line-height: 21px;
      max-width: 194px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 1.25rem;
      line-height: 27px;
      max-width: 270px;
    }
  }
}

.empiricus-pass-point:last-child {
  padding: 30px 20px;

  @media only screen and (min-width: 600px) {
    max-width: 176px;
    padding: 30px 0;
  }

  @media only screen and (min-width: 1024px) {
    max-width: 240px;
    padding: 30px 0;
  }

  @media only screen and (min-width: 1440px) {
    max-width: 280px;
    padding: 62px 0;
  }
}

.point-highlight-block {
  padding: 30px 12px;

  @media only screen and (min-width: 600px) {
    padding: 34px 0;
  }

  @media only screen and (min-width: 1024px) {
    padding: 30px 0;
  }

  @media only screen and (min-width: 1440px) {
    padding: 44px 0;
  }
}

.empiricus-pass-point-highlight  {
  position: relative;

  .point-highlight-block {
    background-color: var(--dark-red);
    border-radius: 4px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;

    @media only screen and (min-width: 600px) {
      height: 230px;
      top: -20px;
    }

    @media only screen and (min-width: 1024px) {
      height: 252px;
      top: -36px;
      width: 234px;
    }

    @media only screen and (min-width: 1440px) {
      height: 345px;
      top: -50px;
      width: 298px;
    }

    .point-image {
      background-color: var(--red);
    }

    span {
      color: var(--white);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Section/Section2.vue